module.exports = __webpack_public_path__ + "media/components/dropdown-search-combo/static/icon-search-grey-678d6f900fb576a72b6f920a2f0b6060.svg";